import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import dayjs from 'dayjs';
import type { RoyaltyMonthlyOut } from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import {
  ROYALTY_MONTHLY_DEFAULT_TAB,
  ROYALTY_MONTHLY_SHOW_TABS,
} from '../constants';
import { RoyaltyMonthlyShowHeader } from './RoyaltyMonthlyShowHeader';
import { RoyaltyMonthlyGeneralTab } from './RoyaltyMonthlyGeneralTab';
import { RoyaltyDailyTab } from './RoyaltyDailyTab';

export const RoyaltyMonthlyShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<RoyaltyMonthlyOut>({
    resource: 'settlement.royalties_monthly',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  useRecordDocumentTitle(
    'settlement.royalties_monthly',
    record && dayjs(record.bucket).format('YYYY-MM')
  );

  const [activeTab, onTabChange] = useShowTab(
    ROYALTY_MONTHLY_SHOW_TABS,
    ROYALTY_MONTHLY_DEFAULT_TAB
  );

  return (
    <Show isLoading={isLoading} contentProps={bareShowContentProps}>
      {record && (
        <>
          <RoyaltyMonthlyShowHeader
            record={record}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && (
              <RoyaltyMonthlyGeneralTab record={record} />
            )}
            {activeTab === 'daily' && <RoyaltyDailyTab record={record} />}
          </div>
        </>
      )}
    </Show>
  );
};
